import skeleton from '../../../components/skeleton';
import banner from "../../../components/banner";
import vueSeamlessScroll from "vue-seamless-scroll";
import './lianTuoRecruit.less'
export default {
    name: "lianTuoRecruit",
    data() {
        return {
            rollList: [
                {
                    src: "img/lianTuoRecruit/swiper2.png",
                    size: 3,
                },
                {
                    src: "img/lianTuoRecruit/swiper3.png",
                    size: 2,
                },
                {
                    src: "img/lianTuoRecruit/swiper1.png",
                    size: 4,
                },
                {
                    src: "img/lianTuoRecruit/swiper2.png",
                    size: 2,
                },
                {
                    src: "img/lianTuoRecruit/swiper3.png",
                    size: 3,
                },
                {
                    src: "img/lianTuoRecruit/swiper1.png",
                    size: 2,
                },
                {
                    src: "img/lianTuoRecruit/swiper2.png",
                    size: 3,
                },
                {
                    src: "img/lianTuoRecruit/swiper3.png",
                    size: 2,
                },
            ],
            rollList2: [
                {
                    src: "/img/lianTuoRecruit/img1.png",
                    size: 3,
                },
                {
                    src: "/img/lianTuoRecruit/img2.png",
                    size: 2,
                },
                {
                    src: "/img/lianTuoRecruit/img3.png",
                    size: 4,
                },
                {
                    src: "/img/lianTuoRecruit/img4.png",
                    size: 2,
                },
                {
                    src: "/img/lianTuoRecruit/img5.png",
                    size: 3,
                },
                {
                    src: "/img/lianTuoRecruit/img6.png",
                    size: 2,
                },
                {
                    src: "/img/lianTuoRecruit/img7.png",
                    size: 3,
                },
                {
                    src: "/img/lianTuoRecruit/img8.png",
                    size: 2,
                },
            ],
            welfare: [
                {
                    pic: 'img/lianTuoRecruit/welfare1.png',
                    title: '有竞争力的薪酬'
                },
                {
                    pic: 'img/lianTuoRecruit/welfare2.png',
                    title: '医疗保险'
                },
                {
                    pic: 'img/lianTuoRecruit/welfare3.png',
                    title: '福利津贴'
                },
                {
                    pic: 'img/lianTuoRecruit/welfare4.png',
                    title: '长期激励计划'
                },
                {
                    pic: 'img/lianTuoRecruit/welfare5.png',
                    title: '有偿休假'
                },
                {
                    pic: 'img/lianTuoRecruit/welfare6.png',
                    title: '学习和发展'
                }
            ],
            recruit: {
                title1: '让商业更智能 让生活更美好',
                info1Pc: '我们一直致力于利用互联网的、科技的力量，<br/>帮助越来越多的线下企业取得成功，<br/>我们正在寻找像你这样的人和我们一起塑造联拓的明天。',
                info1Wap: '我们一直致力于利用互联网的、科技的力量，帮助越来越多的线下企业取得成功，我们正在寻找像你这样的人和我们一起塑造联拓的明天。',
                title2: '我们相信理想 并坚持为之奋斗',
                info2Pc: '在联拓，我们给予所有人平等的创新机会，<br/>我们热衷创造、追求卓越、保持简单而轻松的沟通方式，<br/>同时，也为优秀的你提供更好的福利保障',
                info2Wap: '在联拓，我们给予所有人平等的创新机会，我们热衷创造、追求卓越、保持简单而轻松的沟通方式，同时，也为优秀的你提供更好的福利保障。',
                title3: '帮助全国各地的商户做数字化赋能',
                info3: '我们从收款小精灵的支付插件开始，做到全面赋能门店的数字化营销。<br/>在联拓数科工作意味着赋能线下商业即将成为你的目标。',
                title4: '在联拓数科找到合适的机会',
                info4Pc: '让自己充满无限的可能性，<br/>带来你的才华在联拓数科开启你的职业生涯。',
                info4Wap: '让自己充满无限的可能性，<br/>带来你的才华在联拓数科开启你的职业生涯。'
            },
            talk: {
                info: [
                    '“我们正在为线下门店的数字化经营做出很多令人惊喜的成果，也在不断的帮助更多的客户成功。”'
                ]
            },
            playerOptions: {
                playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
                autoplay: true, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 导致视频一结束就重新开始。
                preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: "zh-CN",
                aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [
                    {
                        type: "video/mp4", // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
                        src: "https://liantuo-1253818706.cos.ap-nanjing.myqcloud.com/media/video.MP4", // url地址
                    },
                ],
                // poster:
                //   "https://p1.music.126.net/5zs7IvmLv7KahY3BFzUmrg==/109951163635241613.jpg?param=600y500", // 你的封面地址
                notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                    timeDivider: true,
                    durationDisplay: true,
                    remainingTimeDisplay: false,
                    fullscreenToggle: true, // 全屏按钮
                },
            }
        }
    },
    components: {
        skeleton,
        banner,
        vueSeamlessScroll
    },
    computed: {
        classOption() {
            return {
                step: 0.7, // 数值越大速度滚动越快
                limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
                hoverStop: false, // 是否开启鼠标悬停stop
                direction: 2, // 0向下 1向上 2向左 3向右
                openWatch: true, // 开启数据实时监控刷新dom
                singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
            };
        },
    }
}
